var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"justify-center my-5"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"6"}},[_c('h2',[_vm._v("Pitch Deck")]),_c('v-btn',{staticStyle:{"letter-spacing":"0","text-transform":"none"},attrs:{"color":"green darken-3","dark":""},on:{"click":_vm.downloadPDF}},[_vm._v(" Download PDF ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }